import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseDialogFormViewDirective } from '@app/shared/base-views/base-dialog-form-view.directive';
import { ToastService } from '@app/core/services/toast/toast.service';

import { IPaymentTemplateEventsService } from '@app/logic/payment-template-events/IPaymentTemplateEventsService';
import { IPaymentTemplateEventDto } from '@classictechsolutions/hubapi-transpiled-enums';
import {
    IPaymentTemplateEventsMapped
} from '@app/logic/payment-template-events/interfaces/i.payment-template-events.mapped';

@Component({
    selector: 'cb-payment-template-events-dialog',
    templateUrl: './payment-template-events-dialog.component.html',
    standalone: false
})
export class PaymentTemplateEventsDialogComponent extends BaseDialogFormViewDirective<IPaymentTemplateEventDto, IPaymentTemplateEventsMapped, IPaymentTemplateEventsService> {

    public readonly eventCodePattern = /^[A-Za-z0-9]+$/;

    constructor(
        public readonly dialogRef: MatDialogRef<PaymentTemplateEventsDialogComponent>,
        public toastService: ToastService,
        @Inject(MAT_DIALOG_DATA) public readonly data: { mappedItem: IPaymentTemplateEventsMapped }
    ) {
        super(dialogRef, toastService);
        this.mappedItem = data.mappedItem;

        if (!this.mappedItem?.id) {
            this.mappedItem.isActive = true;
        }
    }
}
